import { StyleSheet } from 'aphrodite';
import { titles } from '../../../styles/colors';
import { BreakPoints } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	browseAllFeatured: {
		cursor: 'pointer',
		marginTop: 0,
		textAlign: 'right',
		width: 'calc(96% + 40px)',
		[BreakPoints.forMaxWidth(1150)]: {
			width: 'calc(93% + 40px)',
		},
	},
	button: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: 20,
	},
	cardGroupContainer: {},
	cardSectionRow: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		margin: '20px 0',
	},
	categoryTitle: {
		color: titles,
		textTransform: 'capitalize',
	},
	filterHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: 20,
	},
	filterContainer: {
		minWidth: 200,
	},
	filterSelect: {
		minWidth: 200,
	},
	templateCard: {
		':last-child': {
			marginRight: 0,
		},
		marginRight: 20,
		width: '32%',
		[BreakPoints.forMaxWidth(1150)]: {
			width: '31%',
		},
	},
});
